import { useRoutes } from "react-router";
import { RouteObject } from "react-router";
import MainLayout from "~/layouts/MainLayout";
import { mainRouter } from "./main.router";
import { GoogleCallback } from "~/views/auth";

const appRouter: RouteObject[] = [
  {
    path: "/",
    element: <MainLayout />,
    children: mainRouter as RouteObject[],
  },
  {
    path: "/ape-callback",
    element: <GoogleCallback />,
  },
];

export default function AppRouter() {
  return useRoutes(appRouter);
}
